import { useEffect, useState } from 'react';

function Success() {
  const [hasStoredState, setHasStoredState] = useState(false);
  const [showFallback, setShowFallback] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sid = params.get('session_id');
    if (sid) {
      sessionStorage.setItem('stripeSessionId', sid);

      // Fire the GA4 purchase conversion once per real payment.
      // Guard: each Stripe session_id is recorded after firing, so a page
      // refresh or back-navigation to /success does NOT log a second sale.
      // Value is hardcoded to 29 NZD (the floor) because the tier is not in
      // scope here — this never over-reports revenue.
            const gclid = params.get('gclid') || '';

      const firedKey = 'roleready_purchase_fired_' + sid;
      if (!sessionStorage.getItem(firedKey) && typeof window.gtag === 'function') {
        // Re-establish the Google Ads click linkage from the gclid that
        // returned on the /success URL, so the GA4-imported purchase can be
        // attributed to the ad click. Harmless when gclid is absent.
        if (gclid) {
          window.gtag('config', 'AW-18243239622', { gclid });
        }
        window.gtag('event', 'purchase', {
          transaction_id: sid,
          value: 29,
          currency: 'NZD',
        });
        sessionStorage.setItem(firedKey, '1');
      }
    }
    const saved = localStorage.getItem('roleready_kit_state');
    setHasStoredState(!!saved);
  }, []);

  return (
    <div style={{
      minHeight: '100vh',
      background: '#F5F5F5',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
      fontFamily: 'Inter, sans-serif',
    }}>
      <div style={{
        background: 'white',
        borderRadius: '12px',
        padding: '48px 40px',
        maxWidth: '480px',
        width: '100%',
        textAlign: 'center',
      }}>
        <div style={{
          width: '56px',
          height: '56px',
          background: '#E8F5E9',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 24px auto',
          fontSize: '24px',
        }}>✓</div>

        <h1 style={{ color: '#111', fontSize: '24px', margin: '0 0 12px 0', fontFamily: 'Inter, sans-serif' }}>
          Payment confirmed
        </h1>
        <p style={{ color: '#444', fontSize: '16px', lineHeight: '1.6', margin: '0 0 32px 0' }}>
          Your hiring kit is ready. We've sent a confirmation to your email — check your inbox.
        </p>

        <div style={{
          background: '#FFF8E7',
          border: '1px solid #B8860B',
          borderRadius: '8px',
          padding: '16px',
          marginBottom: '32px',
          textAlign: 'left',
        }}>
          <p style={{ color: '#444', fontSize: '14px', margin: '0', lineHeight: '1.5' }}>
            <strong>Your kit was generated before payment.</strong> If you kept the same browser tab open, your kit is still there. If you closed the tab, generate a new kit — your payment covers unlimited regenerations for this role.
          </p>
        </div>

        <button
          onClick={() => {
            if (hasStoredState) {
              // Kit state is in sessionStorage — App will restore it on load
              window.location.href = '/';
            } else {
              setShowFallback(true);
            }
          }}
          style={{
            display: 'block',
            width: '100%',
            background: '#B8860B',
            color: 'white',
            padding: '16px 24px',
            borderRadius: '8px',
            border: 'none',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
            fontFamily: 'Inter, sans-serif',
          }}
        >
          Return to my hiring kit →
        </button>

        {showFallback && (
          <div style={{
            marginTop: '16px',
            padding: '16px',
            background: '#F5F5F5',
            borderRadius: '6px',
            fontSize: '14px',
            color: '#555555',
            textAlign: 'center',
            fontFamily: 'Inter, sans-serif',
          }}>
            Your hiring kit has been sent to your email — check your inbox.
            <br />
            <button
              onClick={() => window.location.href = '/'}
              style={{ marginTop: '12px', color: '#1A7A6E', background: 'none', border: 'none', cursor: 'pointer', fontSize: '14px', fontWeight: '600', fontFamily: 'Inter, sans-serif' }}
            >
              Generate a new kit →
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default Success;
